import { useClientSaveSigningDocuments } from 'api/requests';
import { ClientDocumentGroupName } from 'api/types/data';
import { ClientEntity } from 'api/types/entity';

import { useClientSigningDocumentGroup } from './useClientSigningDocumentGroup';

export const useClientSigningDocuments = (client: ClientEntity) => {
  const {
    signingDocuments,
    loading: submitLoading,
    error: submitError,
  } = useClientSaveSigningDocuments();

  const { documents, formError, loading, onClickDocument, onSubmit } =
    useClientSigningDocumentGroup(
      client,
      ClientDocumentGroupName.OpenAccount,
      signingDocuments,
      submitError
    );

  return {
    documents,
    loading,
    submitLoading,
    formError,
    onClickDocument,
    onSubmit,
  };
};
